// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`LoadingIndicator matches snapshot when loading is false 1`] = `<DocumentFragment />`;
